<div class="flex items-center justify-center p-4 pt-20">
  <edu-error />
</div>
